export default __webpack_public_path__ + "static/media/recorte_19.5ddd34c7.JPG";